import React from "react";
import { useStore } from "effector-react";
import { Box, Typography } from "@material-ui/core";
import { PlayerContainer } from "./player-container";
import { Controls } from "./controls";
import { PlayerTimeRange } from "./timerange";
import { Volume } from "frontend/src/features/change-audio-volume";
import { makeStyles } from "@material-ui/core/styles";
import { $playerCurrentTrack, $playerCurrentTrackSource, } from "frontend/src/domain/player-track-queue";
import { useIsCurrentTrackSourceLoading } from "../../load-player-tracks-source";
import { Skeleton } from "@material-ui/lab";
import { $activeTimetableInterruptionTrack } from "frontend/src/features/play-timetable-interruptions";
import { $activeWebSchedule } from "frontend/src/features/play-web-schedule";
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        range: (_a = {
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                width: 400
            },
            _a[theme.breakpoints.up("md")] = {
                width: 500,
            },
            _a[theme.breakpoints.up("lg")] = {
                width: 700,
            },
            _a),
    });
});
var TrackSourceIndicator = function (_a) {
    var _b, _c;
    var visibleTrack = _a.visibleTrack;
    var trackSource = useStore($playerCurrentTrackSource);
    var activeSchedule = useStore($activeWebSchedule);
    var activeInterruption = useStore($activeTimetableInterruptionTrack);
    var text = "";
    if (activeInterruption) {
        text = activeInterruption.scheduleTitle
            ? "\u0420\u043E\u043B\u0438\u043A \u0438\u0437 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F - " + activeInterruption.scheduleTitle
            : "Ролик из расписания";
    }
    else if ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "web_schedule" || activeSchedule) {
        var playlistTitle = visibleTrack === null || visibleTrack === void 0 ? void 0 : visibleTrack.webSchedulePlaylistTitle;
        text = "\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 - " + ((_c = (_b = activeSchedule === null || activeSchedule === void 0 ? void 0 : activeSchedule.title) !== null && _b !== void 0 ? _b : trackSource === null || trackSource === void 0 ? void 0 : trackSource.attributes.title) !== null && _c !== void 0 ? _c : "") + (playlistTitle ? " (" + playlistTitle + ")" : "");
    }
    else if ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "playlist") {
        text = "\u041F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 - " + trackSource.attributes.title;
    }
    else if ((trackSource === null || trackSource === void 0 ? void 0 : trackSource.type) === "today_timetable") {
        text = "\u0421\u0435\u0442\u043A\u0430 \u0432\u0435\u0449\u0430\u043D\u0438\u044F - " + trackSource.attributes.title;
    }
    return (React.createElement(Box, null,
        React.createElement(Typography, { variant: "caption" }, text)));
};
export var DesktopPlayer = function (_a) {
    var _b;
    var containerClassName = _a.containerClassName, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c;
    var classes = useStyles();
    var track = useStore($playerCurrentTrack);
    var activeInterruption = useStore($activeTimetableInterruptionTrack);
    var visibleTrack = (_b = activeInterruption === null || activeInterruption === void 0 ? void 0 : activeInterruption.track) !== null && _b !== void 0 ? _b : track;
    var isCurrentTrackSourceLoading = useIsCurrentTrackSourceLoading();
    return (React.createElement(PlayerContainer, { className: containerClassName, fullWidth: fullWidth },
        React.createElement(Controls, null),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Box, { mr: 2 }),
            React.createElement(Box, { className: classes.range },
                React.createElement(Box, { display: "flex", justifyContent: "space-between" },
                    React.createElement(Box, null,
                        isCurrentTrackSourceLoading ? (React.createElement(React.Fragment, null,
                            React.createElement(Skeleton, { width: 65, variant: "text" }),
                            React.createElement(Skeleton, { width: 130, variant: "text" }))) : (React.createElement(React.Fragment, null,
                            React.createElement(Typography, null, visibleTrack === null || visibleTrack === void 0 ? void 0 : visibleTrack.title),
                            React.createElement(Typography, { variant: "caption" }, visibleTrack && visibleTrack.type === "public" && visibleTrack.artist))),
                        React.createElement(TrackSourceIndicator, { visibleTrack: visibleTrack }))),
                React.createElement(PlayerTimeRange, { track: visibleTrack }))),
        React.createElement(Volume, null)));
};
